module.exports = __webpack_public_path__ + "static/img/menu_icon4.2381b2c9.png";